// extracted by mini-css-extract-plugin
export default {"dropdowns":"progress_dropdowns__GFVA5"};